import queryString from 'query-string';

const prependWithQuestionMark = input => (input ? `?${input}` : '');

export const removeQueryParams = params => (url, withHost = false, withHistory = false) => {
    let currentUrl = url;

    if (withHistory) {
        if (!url) currentUrl = new URL(url);
        const searchObject = queryString.parse(currentUrl.search);
        params.forEach((param) => {
            delete searchObject[param];
        });

        return currentUrl.pathname + prependWithQuestionMark(queryString.stringify(searchObject)) + currentUrl.hash;
    }
    currentUrl = new URL(url);

    params.forEach((param) => {
        currentUrl.searchParams.delete(param);
    });

    return withHost
        ? currentUrl.toString()
        : currentUrl.pathname + prependWithQuestionMark(currentUrl.search) + currentUrl.hash;
};
